import Model from './Model'
export default class InspectionIndex extends Model {

    resource()
    {
        return 'inspection-indices'
    }
}
